<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title4"><h1 class="title"><strong class="b">Sources</strong></h1>
<p class="p"><span>All references are from The National Archives (formerly Public Record Office, Kew):</span></p>
<p class="p-blanc"><span> <br/></span></p>
<p class="p"><span>HO 45/9315/15372, Lydia Venables; HO 144/235/A51321, Thomas Neal; CRIM 1/43/10, Alfred Chipperfield; HO 144/266/A57652, Alfred Chipperfield; CRIM 1/84, George Chapman; CRIM 1/97/4, Albert Bridgeman; CRIM 1/108/4, Walter Fensham; HO 144/15375, Walter Fensham; PCOM 9/734, Walter Fensham; CRIM 1/293, Arthur Robert Canham; HO 144/20627, Arthur Robert Canham; MEPO 3/1608, Arthur Robert Canham; CRIM 1/940, Frederick Murphy; DPP 2/463, Frederick Murphy; HO 144/20658, Frederick Murphy; HO 144/20659, Frederick Murphy; MEPO 3/874, Frederick Murphy; MEPO 3/1647, Frederick Murphy; CRIM 1/1831, Harry Morley; HO 45/22559, Harry Morley; CRIM 1/2577, Nicky Xinaris; PCOM 9/2201, Nicky Xinaris; CRIM 1/3147, Ronald Henry Marwood; HO 291/242, Ronald Henry Marwood; HO 291/243, Ronald Henry Marwood; PCOM 9/2095, Ronald Henry Marwood; CRIM 1/3946, John Patrick Quinlan</span></p></a></div><a id="title4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783469529_fm03.vue?7e40009a